// extracted by mini-css-extract-plugin
export default {"btn":"BackToTop_btn__YJtSD","visible":"BackToTop_visible__CaniF"};